import {
  AcceptanceAdvancedPollingContext,
  AcceptanceAdvancedState,
  AcceptedAdvancedSigningProcessState,
} from './types';

export const ACCEPTANCE_ADVANCED_SIGNING_PROCESS_NAME = 'acceptanceAdvancedSigningProcess';

export const DEFAULT_ACCEPTANCE_ADVANCED_ID = 'DEFAULT_ACCEPTANCE_ADVANCED_ID';

export const initialAcceptanceAdvancedState: AcceptanceAdvancedState = {
  acceptanceAdvancedId: '',
  acceptanceAdvancedTabUrl: undefined,
  error: undefined,
  lastUpdated: undefined,
  loading: false,
};

export const initialState: AcceptedAdvancedSigningProcessState = {
  acceptancesAdvanced: {
    [DEFAULT_ACCEPTANCE_ADVANCED_ID]: {
      acceptanceAdvancedId: DEFAULT_ACCEPTANCE_ADVANCED_ID,
      loading: false,
      lastUpdated: Date.now(),
    },
  },
};

export const CURRENT_ACCEPTANCE_ADVANCED_CONTEXTS = new Map<string, AcceptanceAdvancedPollingContext>();

export const DEFAULT_POLLING_INTERVAL = 10000;
export const DEFAULT_STOP_POLLING_TIMEOUT = 120000;
export const DEFAULT_MAX_ATTEMPTS = Math.floor(DEFAULT_STOP_POLLING_TIMEOUT / DEFAULT_POLLING_INTERVAL);
